var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(204 -206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-204 206)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 19.5644 0.474055C 19.3081 0.217809 18.8981 0.217809 18.6675 0.474055L 10.0064 9.10955L 1.11467 0.192184C 0.858424 -0.0640615 0.44843 -0.0640615 0.217809 0.192184C -0.0384368 0.44843 -0.0384368 0.858424 0.217809 1.08905L 9.10954 10.0064L 0.192184 18.9238C -0.0640615 19.18 -0.0640615 19.59 0.192184 19.8206C 0.320307 19.9488 0.474055 20 0.653427 20C 0.832799 20 0.986547 19.9488 1.11467 19.8206L 10.032 10.9033L 18.6675 19.5388C 18.7956 19.6669 18.9494 19.7181 19.1288 19.7181C 19.3081 19.7181 19.4619 19.6669 19.59 19.5388C 19.8463 19.2825 19.8463 18.8725 19.59 18.6419L 10.9289 10.0064L 19.5644 1.37092C 19.795 1.11467 19.795 0.704677 19.5644 0.474055Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.88919bce8134dff1f4d7d9f77f7a221a.svg";
export { ForwardRef as ReactComponent };